import { LAYOUT_SPACING, TAB_SPACING } from "@/constants/layout";
import { Box, BoxProps } from "@mui/material";

/**
 * Standard page content wrapper with consistent padding.
 * Use this as the main content container for show/edit/list pages.
 */
export const PageContent = ({ children, sx, ...props }: BoxProps) => {
  return (
    <Box py={LAYOUT_SPACING.PAGE_VERTICAL} px={LAYOUT_SPACING.PAGE_HORIZONTAL} sx={sx} {...props}>
      {children}
    </Box>
  );
};

/**
 * Standard section wrapper with consistent bottom margin spacing.
 * Use for spacing between major sections on a page.
 */
export const PageSection = ({ children, sx, ...props }: BoxProps) => {
  return (
    <Box mb={LAYOUT_SPACING.SECTION} sx={sx} {...props}>
      {children}
    </Box>
  );
};

/**
 * Standard tab content wrapper with consistent padding.
 * Use this as the main content container for tabs.
 */
export const TabContent = ({ children, sx, ...props }: BoxProps) => {
  return (
    <Box pt={TAB_SPACING.PADDING_TOP} sx={sx} {...props}>
      {children}
    </Box>
  );
};
